import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import groups from './groups';
import properties from './properties';
import serviceProviders from './serviceProviders';
import Insights from './insights/Index';
import ExternalSources from '../externalSources';
import myaccount from './myaccount';
const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/insights`} component={Insights} />
      <Route path={`${match.url}/groups`} component={groups} />
      <Route path={`${match.url}/properties`} component={properties} />
      <Route path={`${match.url}/myaccount`} component={myaccount} />
      <Route path={`${match.url}/service-providers`} component={serviceProviders} />
      <Route path={`/app/pages/external-sources`} component={ExternalSources} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
